export { default as Text } from './Text'
export type { TextTag } from './types'
